<template>
	<div class="col-12">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title">Lista de Presupuestos</h3>
				<div class="card-tools">
					<button class="btn btn-outline-success btn-sm mr-2" @click="exportData()">
						<i class="fa fa-file-excel"></i> Exportar
					</button>
					<router-link :to="`/budgets/form`" v-can="'add_budgets'" class="btn btn-sm btn-outline-info">
						<i class="fa fa-plus"></i> Presupuesto
					</router-link>
				</div>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-md-10">
						<label>Buscar :</label>
						<input class="form-control" v-debounce:1s="list" v-model="name">
					</div>
					<div class="col-md-2">
						<label>ID :</label>
						<input class="form-control" v-debounce:1s="list" v-model="id">
					</div>
					<div class="col-md-6">
						<label>Propiedades :</label>
						<select type="text" class="form-control" v-model="search.building_id">
							<option value="">Todos</option>
							<option v-for="(building, index) in catalogue.buildings" :value="building.id" :key="index">
								{{ building.name }}</option>
						</select>
					</div>
					<div class="col-md-6">
						<label>Empresa :</label>
						<select v-model="search.company_id" class="form-control">
							<option value="">Todos</option>
							<option v-for="(company, index) in catalogue.companies_buildings" :key="index"
								:value="company.id"> {{ company.name }}
							</option>
						</select>
					</div>
					<div class="col-md-6" v-if="authUser.organization_charts_id != 2">
						<label>Usuario :</label>
						<select type="text" class="form-control" v-model="search.user_id">
							<option value="">Todos</option>
							<option v-for="(user, index) in catalogue.users_profile" :value="user.id" :key="index">
								{{ user.name }} {{ user.last_name }}</option>
						</select>
					</div>
					<div class="col-md-6">
						<label>Categoría :</label>
						<select type="text" class="form-control" v-model="search.concept_id">
							<option value="">Todos</option>
							<option v-for="(concept, index) in catalogue.concepts" :value="concept.id" :key="index">
								{{ concept.name }}</option>
						</select>
					</div>
					<div class="col-md-6">
						<label>Tipo :</label>
						<select type="text" class="form-control" v-model="search.open">
							<option value="">Todos</option>
							<option value="0">Cerrados</option>
							<option value="1">Abiertos</option>
						</select>
					</div>
					<div class="col-md-6">
					</div>
					<div class="col-md-6">
						<button class="btn mt-4 btn-block btn-outline-secondary"
							:class="search.requires_contract ? 'active' : ''"
							@click="search.requires_contract = search.requires_contract ? '' : 1">
							<i class="fa-solid fa-triangle-exclamation text-warning fa-fade"></i> - Requiere Contrato
						</button>
					</div>

					<div class="col-md-6">
						<button class="btn mt-4 btn-block btn-outline-secondary"
							:class="search.no_repse_required ? 'active' : ''"
							@click="search.no_repse_required = search.no_repse_required ? '' : 1">
							<i class="fa-solid fa-triangle-exclamation text-primary fa-fade"></i> - Requiere REPSE
						</button>
					</div>

				</div>
				<br>
				<div class="row">
					<div class="col-md-12">
						<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
							<li class="nav-item">
								<a class="nav-link active" @click="search.status = 1" data-toggle="pill" role="tab"
									aria-selected="true">Activos</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click="search.status = 2" data-toggle="pill" role="tab"
									aria-selected="false">Terminados</a>
							</li>
							<li class="nav-item">
								<a class="nav-link" @click="search.status = 3" data-toggle="pill" role="tab"
									aria-selected="false">Todos</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="table-responsive">
					<table class="table table-bordered text-center text-sm">
						<thead>
							<tr>
								<th>ID</th>
								<th style="width: 40%;">Datos del presupuesto</th>
								<th style="width: 140px;">Monto</th>
								<th style="width: 140px;">Pagado</th>
								<th style="width: 140px;">Resta</th>
								<th>Opciones</th>
							</tr>
						</thead>
						<tbody v-if="load">
							<tr>
								<td align="center" colspan="6">
									<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
									<h5>Cargando</h5>
								</td>
							</tr>
						</tbody>
						<tbody v-else-if="budgets.total > 0">
							<tr v-for="(budget, index) in budgets.data" :key="index">
								<td>
									{{ budget.id }}
									<br>
									<i v-if="budget.require_contract != 1 && !budget.contract"
										class="fa-solid fa-triangle-exclamation text-warning fa-fade m-1">
									</i>
									<i v-if="budget.no_repse_required != 1 && !budget.repse"
										class="fa-solid fa-triangle-exclamation text-primary fa-fade m-1">
									</i>
									<i v-if="budget.open == 1" class="fa-solid fa-lock text-info fa-fade m-1">
									</i>
									<br>
									<h6><span v-if="budget.status == 1 && search.status == 3" class="badge bg-success">Activo</span></h6>
									<h6><span v-if="budget.status == 2 && search.status == 3" class="badge bg-danger">Terminado</span></h6>
								</td>
								<td class="text-left">
									<!-- Propiedad -->
									<strong>Propiedad:</strong>
									<span v-if="budget.building"> {{ budget.building.name }}</span>
									<span v-else>N/A</span>
									<br>
									<!-- Indiviso -->
									<!-- <strong>Indiviso:</strong>
									<span v-if="budget.departament"> Número {{ budget.departament.number }} / Piso {{
										budget.departament.level }}</span>
									<span v-else>N/A</span>
									<br> -->
									<!-- Empresa -->
									<strong>Empresa:</strong>
									<span v-if="budget.company"> {{ budget.company.name }} </span>
									<span v-else>N/A</span>
									<br>
									<!-- Proveedor -->
									<strong>Usuario:</strong>
									<span v-if="budget.user"> {{ budget.user.name }} {{ budget.user.last_name }}</span>
									<span v-else>Sin usuario</span>
									<br>

									<!-- Moneda -->
									<strong>Moneda : </strong>
									<span v-if="budget.currency"> {{ budget.currency.name }}</span>
									<span v-else>MXN</span>
									<br>

									<span v-if="budget.currency_id==2">
										<strong>Tipo de Cambio : </strong>
										<span> {{ budget.exchange_rate | toCurrency }}</span>
										<br>
									</span>

									<!-- Requiere contrato -->
									<strong>Requiere Contrato:</strong>
									<span v-if="budget.require_contract == 1"> No</span>
									<span v-else>Si</span>
									<br>

									<!-- Descripción -->
									<strong>Descripción:</strong><br>
									<span v-if="budget.description"> {{ budget.description }}</span>
									<span v-else>Sin descripción</span>
									<br>

									<!-- No servicio -->
									<div v-if="budget.no_service">
										<strong>No servicio: </strong><br>
										<span>{{ budget.no_service }}</span>
										<br>
									</div>

									<!-- <span v-if="budget.user_reviewed">
										<b>Autorizado por: <br></b>
										<span class="badge badge-warning">
											{{ budget.user_reviewed.name }} {{ budget.user_reviewed.last_name }}
										</span>
									</span>

									<span v-if="budget.juridical_user">
										<b>Jurídico autorizado por: <br></b>
										<span class="badge badge-info">
											{{ budget.juridical_user.name }} {{ budget.juridical_user.last_name }}
										</span>
									</span> -->

									<div>
										<strong>Autorizado por: </strong><br>
										<div class="badge p-1 badge-success ml-1" v-show="budget.users_approved.length > 0"
											v-for="(validator, index) in budget.users_approved" :key="index">
											<span>{{ validator.user.name }} {{ validator.user.last_name }}</span>
										</div>
										<div v-show="budget.users_approved.length == 0">
											<span>Ninguno</span>
										</div>

									</div>
									<br>
									<br>

									<button @click="showBudget(budget.id)" type="button"
										class="btn btn-sm  m-1 btn-outline-secondary ">
										<i class="fa-solid fa-eye"></i> Ver
									</button>
									<button @click="downloadPDF(budget.id)" type="button"
										class="btn btn-sm  m-1 btn-outline-info ">
										<i class="fa-solid fa-eye"></i> Descargar PDF
									</button>
									<router-link :to="`/budgets/form/${budget.id}`" v-can="'edit_budgets'"
										class="btn btn-outline-primary m-1 btn-sm">
										<i class="fas fa-edit "> </i> Editar
									</router-link>
									<button type="button" @click="deleted(budget.id)" v-can="'deleted_budgets'" v-if="search.status != 3"
										class="btn-outline-danger btn m-1 btn-sm ">
										<i class="fa fa-trash"></i> Eliminar
									</button>
								</td>
								<td class="text-right"  v-if="budget.currency_id>=2">
									{{ (budget.open ? paysCheks(budget.checks, budget.currency_id) + budget.prepaid * budget.exchange_rate :budget.amount) * budget.exchange_rate | toCurrency }}
									<br>
									{{ (budget.open ? paysCheks(budget.checks) + budget.prepaid : budget.amount) | toCurrency }} {{ budget.currency.name }}
								</td>
								<td class="text-right" v-else>
									{{ (budget.open ? paysCheks(budget.checks) + budget.prepaid : budget.amount) | toCurrency }}
								</td>
								<td class="text-right"  v-if="budget.currency_id>=2">
									{{ paysCheks(budget.checks, budget.currency_id) + budget.prepaid * budget.exchange_rate | toCurrency }}
									<br>
									{{ paysCheks(budget.checks) + budget.prepaid | toCurrency }} {{ budget.currency.name }}
								</td>
								<td class="text-right" v-else>
									{{ paysCheks(budget.checks) + budget.prepaid | toCurrency }}
								</td>
								<td class="text-right"  v-if="budget.currency_id>=2">
									{{ (budget.open ? 0 : budget.amount - (paysCheks(budget.checks) + budget.prepaid)) * budget.exchange_rate | toCurrency }}
									<br>
									{{ (budget.open ? 0 : budget.amount - (paysCheks(budget.checks) + budget.prepaid)) | toCurrency }} {{ budget.currency.name }}
								</td>
								<td class="text-right" v-else>
									{{ budget.open ? 0 : budget.amount - (paysCheks(budget.checks) + budget.prepaid) | toCurrency }}
								</td>
								<td>

									<button type="button" @click="approve(budget.id)" v-if="shouldShowAuthorizeButton(budget) && search.status != 3" 
										class="btn-outline-warning btn m-1 btn-sm ">
										<i class="fa fa-check"></i> Autorizar
									</button>

									<!-- <button type="button" @click="approve(budget.id)" v-if="!budget.authorization_user_id"
										v-can="'approve_budgets'" class="btn-outline-warning btn m-1 btn-sm ">
										<i class="fa fa-check"></i> Aprobar
									</button> -->
									<button type="button" v-if="budget.checks.length > 0" @click="showCheck(budget.checks)"
										class="btn m-1 btn-outline-secondary btn btn-sm ">
										<i class="fa-solid fa-hand-holding-dollar"></i> Pagos
									</button>

									<button type="button" @click="approveJuridical(budget.id)"
										v-if="authUser.organization_charts_id == 11 && !budget.juridical_user"
										class="btn-outline-warning btn m-1 btn-sm ">
										<i class="fa-solid fa-check-to-slot"></i> Aprobar jurídico
									</button>

									<button type="button" @click="changeStatus(budget)" v-can="'activate_budgets'" v-if="search.status != 3"
										:class="budget.status == 1 ? 'btn-outline-danger' : 'btn-outline-success'"
										class=" btn m-1 btn-sm ">
										<span v-if="budget.status == 1">
											<i class="fa-solid fa-power-off"></i> Terminar
										</span>
										<span v-else>
											<i class="fa-solid fa-power-off"></i> Activar
										</span>
									</button>
								</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="6">Sin resultados.</td>
							</tr>
						</tbody>
						<tfoot v-if="budgets.total > 0 && load == false">
							<tr class="table-secondary">
								<td colspan="2">
									Total :
								</td>
								<td class="text-right">
									{{ sumdata()[0] | toCurrency }}
								</td>
								<td class="text-right">
									{{ sumdata()[1] | toCurrency }}
								</td>
								<td class="text-right">
									{{ sumdata()[2] | toCurrency }}
								</td>
								<td></td>
							</tr>
						</tfoot>
					</table>
					<pagination v-model="page" :records="budgets.total" :per-page="budgets.per_page" @paginate="list" />
				</div>
			</div>
		</div>

		<ModalTableComponent />
		<ModalFormComponentBudgets :prop_edit="false" />

	</div>
</template>

<script>
import ModalTableComponent from '@/components/checks/ModalTableComponent.vue';

import { mapMutations, mapActions, mapGetters } from 'vuex';
import Pagination from 'vue-pagination-2';
import request from '@/services/request'
import Catalogue from '@/services/catalogue';
import ModalFormComponentBudgets from '@/components/budgets/ModalTableComponent.vue'

export default {
	name: "companies-table",
	components: {
		ModalTableComponent,
		ModalFormComponentBudgets,
		Pagination
	},
	data() {
		return {
			name: '',
			id: '',
			budgets: {},
			search: {
				status: 1,
				search: '',
				id: '',
				building_id: '',
				company_id: '',
				user_id: '',
				concept_id: '',
				requires_contract: '',
				no_repse_required: '',
				open:"",
			},
			page: 1,
			catalogue: new Catalogue(),
			load: false,
		}
	},
	mounted() {
		this.list();
		this.catalogue.get_buildings();
		this.catalogue.get_companies_buildings();
		this.catalogue.get_users_profile(2);
		this.catalogue.get_concepts();
		this.setHeaderTitle('Presupuestos');
	},
	created() {
		Event.$on("event-load-companies", () => {
			this.list();
		});
	},
	methods: {
		downloadPDF(id) {
			let filter = this.globalUrlFiles + '/budgets/'+id+'/pdf';
			window.open(filter, '_blank');
		},
		shouldShowAuthorizeButton(contract) {
			const userId = this.authUser.id;

			const validator = contract.users_approved.find(v =>
				v.user_id === userId
			);

			return !validator;
		},
		sumdata() {
			let vm = this;
			let sum1 = 0;
			let sum2 = 0;
			let sum3 = 0;
			if (this.budgets) {
				this.budgets.data.forEach(function (budget) {

					sum1 += budget.open ? vm.paysCheks(budget.checks,2) + budget.prepaid * (budget.currency_id==2 ? budget.exchange_rate:1) : parseFloat(budget.amount) * (budget.currency_id==2 ? budget.exchange_rate:1);

					sum2 += vm.paysCheks(budget.checks,2) + budget.prepaid * (budget.currency_id==2 ? budget.exchange_rate:1);

					sum3 += budget.open ? 0 : (parseFloat(budget.amount) - (vm.paysCheks(budget.checks) + budget.prepaid)) * (budget.currency_id==2 ? budget.exchange_rate:1);


				});
			}

			return [sum1, sum2, sum3];
		},
		showBudget(id) {
			Event.$emit('event-load-budget', id);
		},
		exportData() {
			let filter = this.globalUrlFiles + '/budgets/export?' + new URLSearchParams(this.search).toString();
			filter += '&user_login=' + this.authUser.id;
			window.open(filter, '_blank');
		},
		showCheck(checks) {
			Event.$emit('event-show-listChecks', checks);
		},
		changeStatus: function (budget) {
			let tit = budget.status == 1 ? 'Termina presupuesto' : 'Activar presupuesto';
			let txt = budget.status == 1 ? 'Seguro que quiere termina el presupuesto' : 'Seguro que quiere activar el presupuesto';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					let _endpoint = '/budgets_status?id=' + budget.id;
					try {
						let response = await request.post(_endpoint).then(function (response) { return response; });
						this.list();
						this.successNotification(response.data.message);
					} catch (error) {
						this.errors = await this.errorNotification(error)
					}
				}
			});
		},
		paysCheks(checks,currency=1) {
			let sum = 0;
			checks.forEach((s) => {
				console.log(s);
				console.log(s.pay);
				if (s.pay.length > 0) {
					s.pay.forEach((b) => {
						console.log(b);
						console.log(b.amount);
						if (b.amount) {
							sum += parseFloat(b.amount) * ((currency == 2&&s.currency_id==2) ? s.exchange : 1);
						}
					});
				}
			});
			return sum;
		},
		deleted: function (id) {
			let tit = 'Eliminar Presupuestos';
			let txt = 'Seguro que quiere eliminar el presupuestos';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then((result) => {
				if (result.isConfirmed) {
					this.callDeleted(id);
				}
			});
		},
		approve: function (id) {
			let tit = 'Aprobar Presupuestos';
			let txt = 'Seguro que quiere aprobar el presupuesto';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					let _endpoint = '/budget_validators';
					let form = {
						id: id
					};
					try {
						let response = await request.post(_endpoint, form).then(function (response) { return response; });
						this.list();
						this.successNotification(response.data.message);
					} catch (error) {
						this.errors = await this.errorNotification(error)
					}
				}
			});
		},
		approveJuridical: function (id) {
			let tit = 'Aprobar Presupuestos';
			let txt = 'Seguro que quiere aprobar el presupuestos';

			this.$swal({
				title: tit,
				text: txt,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Ok',
				cancelButtonText: 'Cancelar'
			}).then(async (result) => {
				if (result.isConfirmed) {
					let _endpoint = '/budgets_approve_juridical';
					let form = {
						id: id
					};
					try {
						let response = await request.post(_endpoint, form).then(function (response) { return response; });
						this.list();
						this.successNotification(response.data.message);
					} catch (error) {
						this.errors = await this.errorNotification(error)
					}
				}
			});
		},
		async callDeleted(id) {
			let _endpoint = '/budgets/' + id;
			try {
				let response = await request.destroy(_endpoint).then(function (response) { return response; });
				this.list();
				this.successNotification(response.data.message);
			} catch (error) {
				this.errors = await this.errorNotification(error)
			}
		},
		showImport() {
			this.$modal.show('example');
		},
		async list(page = 1) {
			this.load = true;
			let service = request;
			let search = this.search;
			search.search = this.name;
			search.id = this.id;
			let _endpoint = '/budgets';
			try {
				let { data } = await service.list(_endpoint, page, search)
				if (data) {
					console.log(data);
					this.budgets = data;
					this.load = false;
				}
			} catch (error) {
				console.log(error);
				this.load = false;
			}
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	watch: {
		'search': {
			handler: function () {
				this.list();
			},
			deep: true
		}
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
}
</script>

<style scoped>
.pagination {
	margin-bottom: 0;
}

.bg-success {
	background-color: #28a745 !important;
}

.bg-primary {
	background-color: #17a2b8 !important;
}
</style>
